import axios from 'axios';

async function getAppVersion() {
    return axios.get('/General/AppVersion/');
}

// spec 000264 (revision 2) — the live load-group minimum (General.LoadGroup.MinChargingCurrentAmps), { amps, watts }.
async function getLoadGroupMinChargingCurrent() {
    return axios.get('/General/LoadGroupMinChargingCurrent/');
}

async function getLandingPageUrl() {
    return axios.get('/General/LandingPageUrl/');
}

// spec 000304 (AC-11) — is the QR's charger linked to a landing page whose module is on. Anonymous, like getLandingPageUrl.
async function getLandingPageAvailability(partyId, uid, connectorNumber) {
    return axios.get(`/General/LandingPageAvailability/${encodeURIComponent(partyId)}/${encodeURIComponent(uid)}/${encodeURIComponent(connectorNumber)}`);
}

const generalService = {
    getAppVersion,
    getLandingPageUrl,
    getLandingPageAvailability,
    getLoadGroupMinChargingCurrent
}

export default generalService;